import { clsx } from "clsx";
import { twMerge } from "tailwind-merge"

export function cn(...inputs) {
  return twMerge(clsx(inputs));
}

export function formatDate(dateString, options = {}) {
  if (!dateString) return '';
  
  const date = new Date(dateString);
  const defaultOptions = {
    weekday: 'short',
    day: 'numeric',
    month: 'short',
    year: 'numeric',
    ...options
  };
  
  return date.toLocaleDateString('en-AU', defaultOptions);
}

export function formatTime(dateString) {
  if (!dateString) return '';
  
  const date = new Date(dateString);
  return date.toLocaleTimeString('en-AU', {
    hour: '2-digit',
    minute: '2-digit',
    hour12: true
  });
}

export function formatDateTime(dateString) {
  if (!dateString) return '';
  return `${formatDate(dateString)} at ${formatTime(dateString)}`;
}

export function formatDuration(minutes) {
  if (!minutes && minutes !== 0) return '';
  
  const hours = Math.floor(minutes / 60);
  const mins = minutes % 60;
  
  if (hours === 0) return `${mins}m`;
  if (mins === 0) return `${hours}h`;
  return `${hours}h ${mins}m`;
}

export function getStatusColor(status) {
  const colors = {
    draft: 'bg-zinc-100 text-zinc-700',
    confirmed: 'bg-blue-50 text-blue-700',
    assigned: 'bg-purple-50 text-purple-700',
    accepted: 'bg-indigo-50 text-indigo-700',
    in_progress: 'bg-amber-50 text-amber-700',
    completed: 'bg-emerald-50 text-emerald-700',
    cancelled: 'bg-red-50 text-red-700',
    rescheduled: 'bg-orange-50 text-orange-700',
  };
  
  return colors[status] || 'bg-zinc-100 text-zinc-700';
}

export function getStatusLabel(status) {
  const labels = {
    draft: 'Draft',
    confirmed: 'Confirmed',
    assigned: 'Assigned',
    accepted: 'Accepted',
    in_progress: 'In Progress',
    completed: 'Completed',
    cancelled: 'Cancelled',
    rescheduled: 'Rescheduled',
  };
  
  return labels[status] || status;
}
